import DetailWebView from './webview';
import GameWebView from './game-webview';
export {GameWebView};

export default DetailWebView;
